export default "__VITE_ASSET__Tx441k2Q__"